import { useContext } from "react";
import { ExpandedFacetsContext } from "../context/expanded-facets-context";

export const useExpandedFacetsContext = () => {
  const context = useContext(ExpandedFacetsContext);

  if (context) {
    return context;
  }

  return {};
};
